import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

import {
  signOut,
  updateUserTermsVersion,
} from '../actions';

const cookies = new Cookies();

class TermsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.updateUserTerms = this.updateUserTerms.bind(this);
  }

  handleLogout(event) {
    event.preventDefault();
    const { dispatch, history } = this.props;
    dispatch(signOut(cookies, history)).then(() => {
      window.location.href = '/';
    });
  }

  updateUserTerms() {
    const { dispatch } = this.props;
    const { currencyHandle, emailOnLogin } = this.state;
    const data = {
      termsVersion: process.env.REACT_APP_TERMS_VERSION,
    };
    this.setState({submitted: true})
    dispatch(updateUserTermsVersion(data))
      .then((res) => {
        if (res.type === 'UPDATE_USER_TERMS_VERSION_SUCCESS') {
          this.props.toggleModal(null);
        }
        if (res.type === 'UPDATE_USER_TERMS_VERSION_FAIL') {
          this.setState({submitted: false})
        }
      });
  }

  render() {
    const { submitted } = this.state;
    let complete;

    return (
      <div className="modal-content">
        <div className="modal-heading">
          Update to the Vaultoro Terms
        </div>
        <div className="modal-body">
          <p>
            To continue using the Vaultoro service, please agree to our terms.
          </p>
          <p>
            You can view our latest terms <a href="https://vaultoro.com/terms-of-use/">here</a>.
          </p>
        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <button className="button" type="button" onClick={(e) => this.handleLogout(e)}>
            <span>
              Cancel
            </span>
          </button>
          <button className="vlt-button" type="button" onClick={() => this.updateUserTerms()} disabled={submitted}>
            <span>
              I agree
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
  resetCode: state.user.resetCode,
});

export default connect(mapStateToProps)(TermsModal);
